export interface HighlightSegment {
  text: string;
  highlighted: boolean;
}

export function getHighlightSegments(text: string, query: string): HighlightSegment[] {
  if (!text) {
    return [];
  }

  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return [{ text, highlighted: false }];
  }

  const lowerText = text.toLowerCase();
  const segments: HighlightSegment[] = [];
  let startIndex = 0;
  let matchIndex = lowerText.indexOf(normalizedQuery, startIndex);

  while (matchIndex !== -1) {
    if (matchIndex > startIndex) {
      segments.push({ text: text.slice(startIndex, matchIndex), highlighted: false });
    }

    segments.push({
      text: text.slice(matchIndex, matchIndex + normalizedQuery.length),
      highlighted: true,
    });
    startIndex = matchIndex + normalizedQuery.length;
    matchIndex = lowerText.indexOf(normalizedQuery, startIndex);
  }

  if (startIndex < text.length) {
    segments.push({ text: text.slice(startIndex), highlighted: false });
  }

  return segments.length ? segments : [{ text, highlighted: false }];
}
